import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { PalmettoAccount, RepAccess } from '@/types';
import { initialState } from './app.state';

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    SET_JWT_TOKEN: (state, action: PayloadAction<string | null>) => {
      state.jwtToken = action.payload;
    },
    SET_AUTH: (
      state,
      action: PayloadAction<{ account: PalmettoAccount; access: RepAccess } | null>,
    ) => {
      state.account = action.payload?.account ?? null;
      state.access = action.payload?.access ?? null;
    },
    SET_NAV_OPEN: (state, action: PayloadAction<boolean>) => {
      state.navOpen = action.payload;
    },
    SIGN_OUT: (state) => {
      state.jwtToken = null;
      state.account = null;
      state.access = null;
      state.navOpen = false;
    },
  },
});

export const { SET_JWT_TOKEN, SET_AUTH, SET_NAV_OPEN, SIGN_OUT } = appSlice.actions;

export default appSlice.reducer;
